import { render, staticRenderFns } from "./ResellerInvoiceViewDetailsResellerInvoiceItemForm.vue?vue&type=template&id=59d8b290"
import script from "./ResellerInvoiceViewDetailsResellerInvoiceItemForm.vue?vue&type=script&lang=js"
export * from "./ResellerInvoiceViewDetailsResellerInvoiceItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports